module.exports = __webpack_public_path__ + "files/16dac5c47a16678ae89f79488aab39c2.png";